<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/show/ScreenRoom' }">放映厅列表</el-breadcrumb-item>
      <el-breadcrumb-item>视频列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 返回 添加 -->
    <el-form :inline="true" style="margin-top: 20px;">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-back" @click="toScreen()">返回</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openVideo()">添加</el-button>
      </el-form-item>
    </el-form>

    <!-- 列表 -->
    <el-table size="small" :data="VideoData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" sortable prop="screenName" label="放映厅名称" width="120"></el-table-column>
      <el-table-column align="center" sortable prop="url" label="视频" width="120">
        <template slot-scope="scope">
          <video :src="scope.row.url" style="width: 80px;margin-left: 14px;min-height:80px;" v-if="scope.row.url" controls>
            
          </video>
          <div v-if="scope.row.url == null">没有视频</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="episodes" label="集数" width="120"></el-table-column>
      <el-table-column align="center" sortable prop="amount" label="价格(奖学金)" width="120"></el-table-column>
      <el-table-column align="center" sortable prop="videoImage" label="视频封面图" width="120">
        <template slot-scope="scope">
          <el-image v-if="scope.row.videoImage" style="width: 90px;height: 90px;" :src="scope.row.videoImage"
            :preview-src-list="[scope.row.videoImage]" />
          <div v-if="scope.row.videoImage == null">没有图片</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="createTime" label="创建时间" width="160">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="400">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="getVideoxq(scope.row)">查看视频详情</el-button>
          <el-button size="mini" type="primary" @click="openVideo(scope.row)">修改</el-button>
          <el-button size="mini" type="primary" @click="deleVideo(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog :title="tit" :visible.sync="editFormVisiible" width="40%">
      <el-form label-width="120px">
        <!-- <el-form-item label="放映厅ID" prop="screenId">
              <el-input size="small" v-model="screenId" auto-complete="off" placeholder="请输入放映厅ID"></el-input>
          </el-form-item> -->
        <el-form-item label="播放路径" prop="url">
          <div style="display: flex; align-items: center;">
            <el-upload action="" :http-request="mainVideoUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <video :src="url" style="width: 80px;margin-left: 14px;min-height:80px;" v-if="url" controls>
     
            </video>
          </div>
        </el-form-item>
        <el-form-item label="集数" prop="episodes">
          <el-input size="small" v-model="episodes" auto-complete="off" placeholder="请输入视频集数"></el-input>
        </el-form-item>
        <el-form-item label="价格（奖学金）" prop="amount">
          <el-input size="small" v-model="amount" auto-complete="off" placeholder="请输入价格（奖学金）"></el-input>
        </el-form-item>
        <el-form-item label="视频封面图">
          <div style="display: flex; align-items: center;">
            <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <img v-if="videoImage != ''" :src="videoImage" style="width: 140px;height: 140px;margin-left: 14px;">
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog()'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="addVideo()" v-if="tit == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="upVideo()" v-if="tit == '修改'">修改</el-button>
      </div>
    </el-dialog>

    <!-- 视频详情 -->
    <el-dialog title="视频详情页：" :visible.sync="editFormDetails">
      <el-form label-width="140px">
        <el-form-item label="放映厅id" prop="screenId">
          <span v-html="this.Details.screenId"></span>
        </el-form-item>
        <el-form-item label="放映厅名称" prop="screenRoomName">
          <span v-html="this.screenRoomName"></span>
        </el-form-item>
        <el-form-item label="集数：" prop="episodes">
          <span v-html="this.Details.episodes"></span>
        </el-form-item>
        <el-form-item label="价格（奖学金）：" prop="amount">
          <span v-html="this.Details.amount"></span>
        </el-form-item>
        <el-form-item label="视频：" prop="url">
          <video :src="this.Details.url" style="width: 80px;margin-left: 14px;min-height:80px;" v-if="this.Details.url" controls></video>
        </el-form-item>
        <el-form-item label="视频封面图：" prop="videoImage">
          <el-image v-if="this.Details.videoImage" style="width: 140px;height: 140px;margin-left: 14px;"
            :src="this.Details.videoImage" :preview-src-list="[this.Details.videoImage]" />
        </el-form-item>
        <el-form-item label="创建时间：" prop="createTime">
          {{ transformDate(this.Details.createTime) }}
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import client from "@/utils/ossClient.js";
import { getScreenVideoList } from '../api/userMG'
import { getScreenVideoInfo } from '../api/userMG'
import { addScreenVideo } from '../api/userMG'
import { deleteScreenVideo } from '../api/userMG'
import { upScreenVideo } from '../api/userMG'
export default {
  data() {
    return {
      editFormVisiible: false,
      url: '',
      episodes: '',
      screenId: this.$route.query.id,
      screenRoomName: this.$route.query.name,
      videoImage: '',
      amount: '',
      loading: false,
      tit: '添加',
      VideoData: [],
      editFormDetails: false,
      Details: [],
    }
  },
  created() {
    this.getVideo(1)
    console.log(this.screenId)
  },
  methods: {
    // 返回上一页
    toScreen() {
      this.$router.go(-1)
    },
    // 查看视频详情
    getVideoxq(row) {
      this.loading = true;
      this.editFormDetails = true;
      let data = {
        id: row.id
      }
      getScreenVideoInfo(data).then((res) => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.Details = res.data.data;
          return;
        }
      })
    },
    // 删除
    deleVideo(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteScreenVideo(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getVideo(1)
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 修改
    upVideo() {
      this.loading = true,
        upScreenVideo({
          id: this.id,
          url: this.url,
          amount: this.amount,
          episodes: this.episodes,
          screenId: this.screenId,
          videoImage: this.videoImage
        }).then((res) => {
          if (res.code == 200) {
            this.loading = false
            this.$message.success(res.msg)
            this.editFormVisiible = false
            this.getVideo(1)
          } else {
            this.editFormVisiible = false
            this.$message.error(res.msg)
          }
        })
    },
    // 添加
    addVideo() {
      this.loading = true,
        addScreenVideo({
          url: this.url,
          amount: this.amount,
          episodes: this.episodes,
          screenId: this.screenId,
          videoImage: this.videoImage
        }).then((res) => {
          if (res.code == 200) {
            this.loading = false
            this.$message.success(res.msg)
            this.editFormVisiible = false
            this.getVideo(1)
          } else {
            this.editFormVisiible = false
            this.$message.error(res.msg)
          }
        })
    },
    // 关闭编辑对话框
    closeDialog() {
      this.editFormVisiible = false
      this.$message({
        type: 'info',
        message: '已取消编辑'
      })
    },
    // 自定义上传方法 视频的
    mainVideoUpload(file) {
      this.loading=true
      // 判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["video", "mp4"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
      this.loading=false
          if (res.url) {
            this.url = res.url
            // this.image.push(res.url)
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },
    // 自定义上传方法 图片的
    mainImgUpload(file) {
      // 判断扩展名
      this.loading=true
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
      this.loading=false
          if (res.url) {
            this.videoImage = res.url
            // this.image.push(res.url)
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },
    //打开编辑页面
    openVideo(row) {
      this.editFormVisiible = true;
      if (row != undefined && row != "undefined") {
        this.tit = "修改"
        this.id = row.id
        this.url = row.url
        this.amount = row.amount
        this.episodes = row.episodes
        this.screenId = row.screenId
        this.videoImage = row.videoImage
      } else {
        this.tit = "添加"
        this.url = ""
        this.amount = ""
        this.episodes = ""
        this.videoImage = ""
        this.screenId = row.screenId
      }
    },
    // 获取列表数据
    getVideo(page) {
      this.loading = true;
      let data = {
        screenRoomName: this.screenRoomName,
        episodes: '',
        page: (page - 1) * 20
      }
      getScreenVideoList(data).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          console.log(res.data.list)
          this.VideoData = res.data.list;
          return;
        } else {
          this.$Message({
            type: "info",
            message: res.msg
          })
        }
      })
    }
  }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/Video.vue